
// //new updated


import React, { useState } from 'react';
import { FaBars } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Sidebar from './Sidebar'; 
import FooterButton from './FooterButton';

const Category = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const navigate = useNavigate();
const [activeCategory, setActiveCategory] = useState('all');

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };



const categoryIcons = {
  All: 'https://as2.ftcdn.net/v2/jpg/04/97/08/75/1000_F_497087583_WNfnSVmHSwoNp1iprUUt5CLUuNRIhnnC.jpg',
  Mobiles: 'https://www.pngarts.com/files/3/Smartphone-Mobile-PNG-Image-Background.png',
  Tools: 'https://www.pngall.com/wp-content/uploads/10/Tools-PNG-Photos.png',
  Plumbing: 'https://i.pinimg.com/originals/ae/65/fb/ae65fbf16b24ed45bb172e932dc79807.png',
  Painting: 'https://png.pngtree.com/png-vector/20231116/ourmid/pngtree-isolated-white-background-of-an-aged-png-image_10552531.png',
  Cleaning: 'https://static.vecteezy.com/system/resources/previews/041/642/641/original/ai-generated-cleaning-product-isolated-on-transparent-background-png.png',
  'Mens Clothes': 'https://cdn-icons-png.flaticon.com/512/892/892458.png',
  'Women Clothes': 'https://cdn-icons-png.flaticon.com/512/892/892451.png',
  Unisex: 'https://img.huffingtonpost.com/asset/6494679e2000001b00c8b6b6.png?ops=scalefit_960_noupscale',
  Footwear: 'https://th.bing.com/th/id/R.588c91bfba1ed32b8b0ae41dc7fb7c4d?rik=2cAi1QHrzWsBpQ&riu=http%3a%2f%2fpluspng.com%2fimg-png%2fshoes-png--1200.png&ehk=LDK2zKZ4gGD3lYE7ncWJOb8tGdJLrU046BiOz1wqbAQ%3d&risl=&pid=ImgRaw&r=0',
  Cosmetics: 'https://cdn-icons-png.flaticon.com/512/2920/2920242.png',
};

const categories = Object.keys(categoryIcons).map((name) => ({
  name,
  slug: name.toLowerCase().replace(/\s+/g, '-'),
  image: categoryIcons[name],
}));



  return (
    <div className="container-fluid category-layout">
      {/* Sidebar */}
      <Sidebar isOpen={sidebarOpen} toggleSidebar={toggleSidebar} />

      {/* Overlay */}
      {sidebarOpen && <div className="sidebar-overlay" onClick={toggleSidebar}></div>}

      {/* Main Content */}
      <div className="main-content">
        <div className="top-bar">
          <button className="menu-btn" onClick={toggleSidebar}>
            <FaBars size={24} />
          </button>
          <h2>Shop by Category</h2>
        </div>

<div className="category-tabs">
  {categories.map((category) => (
    <div
      key={category.slug}
      className={`category-tab ${activeCategory === category.slug ? 'active' : ''}`}
      onClick={() => setActiveCategory(category.slug)}
    >
      <img src={category.image} alt={category.name} />
      <span>{category.name}</span>
    </div>
  ))}
</div>



        <FooterButton></FooterButton>
      </div>

      {/* Styles */}
      <style>{`
        .top-bar {
          display: flex;
          align-items: center;
          padding: 10px;
          background: linear-gradient(135deg, rgba(111, 0, 255, 0.99), rgb(24, 200, 223), rgb(0, 0, 0));
          border-bottom: 1px solid;
          position: sticky;
          top: 0;
         
          color: white;
        }

        .menu-btn {
          background: none;
          border: none;
          margin-right: 16px;
          cursor: pointer;
          color: white;
        }

        .sidebar-overlay {
          position: fixed;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(0,0,0,0.4);
          z-index: 900;
        }

        .main-content {
          margin-left: 0;
          transition: margin-left 0.3s ease;
          padding: 16px;
        }

        @media (min-width: 768px) {
          .main-content {
            margin-left: 300px;
          }
        }

        .category-list {
          display: flex;
          flex-wrap: wrap;
          gap: 12px;
          margin-top: 20px;
        }

        .category-item {
          padding: 12px 24px;
          background-color: #232f3e;
          color: white;
          border: none;
          border-radius: 4px;
          cursor: pointer;
          font-weight: 600;
          transition: background-color 0.3s ease;
        }

        .category-item:hover {
          background-color: #37475a;
        }
      `}</style>
    </div>
  );
};

export default Category;
